import script from "./Check.vue?vue&type=script&lang=ts&setup=true&name=Check"
export * from "./Check.vue?vue&type=script&lang=ts&setup=true&name=Check"

import "./Check.vue?vue&type=style&index=0&id=278d50ac&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278d50ac"]])

export default __exports__